import { useReward } from 'react-rewards';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  randomCalendarColor,
  serviceVariantColors,
} from 'presentations/views/styles/color';

interface Props {
  className?: string;
}

const emojis = [
  '&#x1f389;', // 🎉
  '&#x1f90e;', // 🤎
];

const animations = {
  confetti: {
    lifetime: 200,
    elementCount: 120,
    spread: 110,
    startVelocity: 36,
    colors: serviceVariantColors,
  },
  emoji: {
    lifetime: 200,
    elementCount: 30,
    spread: 120,
    startVelocity: 48,
    emoji: [emojis[1]],
  },
};

export default function Component(props: Props) {
  const [isOpen, setIsOpen] = useState(true);
  const colors = useMemo(() => {
    return [
      randomCalendarColor(),
      randomCalendarColor(),
      randomCalendarColor(),
      randomCalendarColor(),
    ];
  }, []);

  const { reward, isAnimating } = useReward('rewardId', 'confetti', {
    ...animations.confetti,
    colors,
  });

  useEffect(() => {
    reward();
    setIsOpen(false);
  }, [isOpen]);

  return <span id="rewardId" />;
}
